import * as Sentry from "@sentry/react";
import React from "react";

import type { User } from "~/common/types";

export const useUser = () => {
  const [user, _setUser] = React.useState<User | null>(null);

  const setUser = React.useCallback((newUser: User | null) => {
    _setUser(newUser);
    if (newUser) {
      Sentry.setUser({
        email: newUser.email ?? undefined,
        username: newUser.displayName ?? undefined,
        role: newUser.role ?? undefined,
        tenants: newUser.tenants,
      });
    } else {
      Sentry.setUser(null);
    }
  }, []);

  return [user, setUser] as const;
};
